<template>
  <div id="app">
    <!-- <Dealer></Dealer> -->
      <Dealer></Dealer>
  </div>
</template>

<script>
import Dealer from './page/dealer'

export default {
  name: 'App',
  components: {
    Dealer
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue